<template>
  <div>
    <!-- <div class="header">
      <div>账号：</div>
      <input type="text" v-model="account" placeholder="请输入账号" />
    </div>
    <div class="header">
      <div>密码：</div>
      <input type="text" v-model="password" placeholder="请输入密码" />
    </div>
    <div class="header">
      <div>门店：</div>
      <input type="text" v-model="store" placeholder="请输入门店" />
    </div>
    <button @click="TextLogin('测试')">测试登录</button>
    <button @click="TextLogin('灰度')">灰度登录</button>
    <button @click="TextLogin('正式')">正式登录</button>
    <div style="width: 300px;white-space: normal;">{{ token }}</div>-->
    <div>设置倒计时的时间(秒)：</div>
    <input type="number" v-model="timeNum" placeholder="请输入倒计时时间" style="width: 300px;height: 100px;" />
    <button type="button" @click="kaiqi">开始倒计时</button>
  </div>
</template>

<script>
import { mdMIwen } from "@/utils/miwen.js";
import cryptoJs from 'crypto-js';

export default {
  name: "LayoutIndex",
  data() {
    return {
      account: "15062",
      password: "ch000000",
      store: "60010",
      token: '',
      loading: '',
      numId: 1,
      timeNum: ''

    };
  },
  mounted() {
    // this.kaiqi()
  },
  methods: {
    kaiqi() {
      this.loading = setInterval(() => {
        this.numId = this.numId + 1;
        this.requestNotificationPermission()
        if (this.numId > 6) {
          clearInterval(this.loading);
        }
      }, Number(this.timeNum) * 1000);
    },
    // 请求通知权限
    requestNotificationPermission() {
      console.log("请求通知权限")
      if (Notification.permission === "granted") {
        console.log("通知权限已经被授予");
        this.showNotification("到点了！！！", "快喝水！！！！", "https://image.yueheji.com/CaiHuaProdCache/admin/upload/20241225/20241225170924_8571.jpg");
      } else if (Notification.permission !== "denied") {
        Notification.requestPermission().then(permission => {
          if (permission === "granted") {
            console.log("用户已授予通知权限");
            this.showNotification("到点了！！！", "快喝水！！！！", "https://image.yueheji.com/CaiHuaProdCache/admin/upload/20241225/20241225170924_8571.jpg");


          } else {
            console.log("用户拒绝了通知权限");
          }
        });
      }
    },
    showNotification(title, body, icon) {
      if (Notification.permission === "granted") {
        const notification = new Notification(title, {
          body: body,        // 通知内容
          icon: icon,        // 通知图标
          tag: 'unique-tag', // 用于标识通知的标签
          renotify: true     // 在同一通知关闭后重新通知
        });

        // 添加点击事件，点击通知时触发的回调
        notification.onclick = function () {
          window.focus();
          notification.close();  // 点击后关闭通知
        };

        // 设置通知的自动关闭时间
        setTimeout(() => {
          notification.close();
        }, 10000);  // 5秒后自动关闭通知
      }
    },
    async TextLogin(text) {
      const info = {
        userName: this.account,
        passwordMd5: cryptoJs.MD5(this.password).toString(),
      }
      const res = await mdMIwen('Identity', 'LoginByMd5', info, text, '');
      const res1 = await mdMIwen('Identity', 'LoginBySignUserID', res.Result.UserId, text, res.Result.ValidateAccessToken);
      console.log(res);
      console.log(res1);
      const res2 = await mdMIwen('Identity', 'AgentCustomer', { terminalCode: this.store }, text, res1.Result.ValidateAccessToken);
      console.log(res2);
      this.token = res2.Result.ValidateAccessToken;
    }
  },
};
</script>

<style lang="less">
.header {
  display: flex;
  height: 40px;
  margin-left: 100px;
  margin-top: 50px;
  margin-bottom: 20px;
}

button {
  margin-left: 20px;
}
</style>
